import ClipboardJS from 'clipboard';

export default function () {
    const toCopy = document.querySelectorAll('[data-clipboard]');

    toCopy.forEach(elem => {
        const copyTrigger = document.createElement('span');
        const inner = document.createElement('span');

        copyTrigger.insertAdjacentElement('afterbegin', inner);
        copyTrigger.classList.add('copy-trigger');
        copyTrigger.setAttribute('title', elem.getAttribute('data-clipboard'));
        elem.insertAdjacentElement('beforeend', copyTrigger);
        copyTrigger.addEventListener('click', function (e) {
            e.preventDefault();
        });
    });

    var clipboard = new ClipboardJS('.copy-trigger', {
        text: function (trigger) {
            const parent = trigger.parentElement;
            const dataClipboardItem = parent.getAttribute('data-clipboard-item');

            return dataClipboardItem ? dataClipboardItem : parent.textContent;
        }
    });

    clipboard.on('success', function (e) {
        e.clearSelection();
        e.trigger.classList.add('success');
        setTimeout(function () {
            e.trigger.classList.remove('success');
        }, 750);
    });
}